import { render, staticRenderFns } from "./recipeCreateModal.vue?vue&type=template&id=3b67b7ed&"
import script from "./recipeCreateModal.vue?vue&type=script&lang=ts&"
export * from "./recipeCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports